import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Form, Icon, Input } from "semantic-ui-react";
import { DialogService } from "../../services/dialog-service";
import { AppStore } from "../../stores/app-store";
import { App } from "../../stores/models/app";
import { AppAction } from "../../stores/models/app-action";
import { EditorPane } from "../common/editor-pane";

declare var toastr: any;

interface IActionEditorProps{
	show: boolean;
	action: AppAction;
	app: App;
	appStore?: AppStore;
	onClose?(): void;
}

interface IActionEditorState{
	errorMessage?: string;
	name?: string;
	externalId?: string;
	description?: string;
}

@inject("appStore") @observer
export class ActionEditor extends React.Component<IActionEditorProps, IActionEditorState>
{
	constructor(props, state){
		super(props, state);

		this.state = {"errorMessage": "", "name": "", "externalId": null, "description": ""};
		this.handleSave = this.handleSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

	componentWillReceiveProps(nextProps){
		this.setActionState(nextProps.action);
	}

	setActionState(action){
		if(action){
			this.setState({"name": action.name || "", "externalId": action.externalId || 0, "description": action.description || ""});
		}
	}

	async handleChange(e: any, {name, value}){
		this.props.action.updateProperty(name, value);
		this.setState({[name]: value});
	}

	async handleSave(ev){
		ev.stopPropagation();
		ev.preventDefault();
		try{
			await this.props.action.save();
			toastr.success("Change Saved");
			this.setState({"errorMessage": null});
		} catch(err) {
			console.error(err);
			this.setState({"errorMessage": err.message});
			return false;
		}
	}

	handleCancel() {
		if(this.props.onClose){
			this.props.onClose();
		}
	}

	render() {
		return (
			<div>
				<EditorPane show={this.props.show} onClose={this.handleCancel} title="Action Editor">
				{this.props.action &&
					<div>
						<Form onSubmit={this.handleSave}>
							<Form.Field>
								<Form.Input required type="text" label="Name" name="name" value={this.state.name} onChange={this.handleChange}  />
							</Form.Field>
							<Form.Field className="field">
								<Form.Input required type="text" label="External Id" name="externalId" value={this.state.externalId} onChange={this.handleChange}  />
							</Form.Field>
							<Form.Field>
								<Form.Input type="text" label="Description" name="description" value={this.state.description} onChange={this.handleChange}  />
							</Form.Field>
							<Form.Group>
									<Form.Button type="submit" icon color="green" labelPosition="left">
										<Icon name="save" />
										Save
									</Form.Button>
									<Form.Button icon color="blue" labelPosition="left" onClick={this.handleCancel}>
										<Icon name="remove" />
										Close
									</Form.Button>
								</Form.Group>
						</Form>
						<hr />
						<br />
						{this.state.errorMessage &&
							<div className="ui red icon message">
								<i className="warning sign icon"></i>
								{this.state.errorMessage}
							</div>
						}
					</div>
				}
				</EditorPane>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/apps/action-editor.tsx